export default "__VITE_ASSET__DMlX4ayf__"